import { createFileRoute } from "@tanstack/react-router";

import { TrendsPage, trendsHead } from "../components/prenoms/trends-page";
import { namesApi } from "../lib/api";
import { seo } from "../lib/head";

export const Route = createFileRoute("/prenoms/tendances")({
  staticData: { ssr: true },
  loader: ({ context }) =>
    context.queryClient.query({
      queryKey: ["prenoms-trends"],
      queryFn: namesApi.trends,
      staleTime: "static",
    }),
  head: ({ loaderData }) => (loaderData ? seo(trendsHead(loaderData)) : {}),
  component: Page,
});
function Page() {
  return <TrendsPage data={Route.useLoaderData()} />;
}
